export const getIsLinkExternal = (href: string | undefined) => {
  if (href) {
    const includesHttp = href.includes("http");
    const includesMail = href.includes("mailto");

    return includesHttp || includesMail;
  }
  return false;
};
